import './dictionaries'
import './form'
import './input'
import './window'
import './icon';
import './OnlineCashes';
import './MagHistory';
import './MagAddValues';
import './MagAddFiltersDialog';

import Vue from 'vue';
import SearchKeyEnter from './SearchKeyEnter.vue'
import magGroup from './mag-group.vue'

Vue.component('mag-group', magGroup);
Vue.component('SearchKeyEnter', SearchKeyEnter);
